import * as React from 'react';

import { Info } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { Maybe } from 'types/UtilityTypes';
import { SellRateRoundingRules } from 'types/agents/QuickQuoteAgent';

export const RoundingRulesNote = ({
  rules,
}: {
  rules?: SellRateRoundingRules;
}): Maybe<React.JSX.Element> => {
  if (!rules?.roundToNearest) {
    return null;
  }

  const roundingDirection = rules.roundUp ? 'up' : 'down';

  return (
    <Flex direction='row' gap='xs' align='center'>
      <Typography
        variant='body-xxs'
        textColor='muted'
        className='italic'
        weight='light'
      >
        (rounded {roundingDirection} to nearest $
        {rules.roundToNearest.toFixed(0)})
      </Typography>

      <Tooltip delayDuration={10}>
        <TooltipTrigger asChild>
          <button
            type='button'
            className='inline-flex items-center justify-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400'
            aria-label='Sell rate rounding rules info'
          >
            <Info className='w-3.5 h-3.5 stroke-neutral-500! stroke-2' />
          </button>
        </TooltipTrigger>
        <TooltipContent className='max-w-52 mr-2 p-1.5'>
          <Typography variant='body-xxs' textColor='lessMuted'>
            If you need to change sell rate rounding rules, contact our team!
          </Typography>
        </TooltipContent>
      </Tooltip>
    </Flex>
  );
};
